export default __webpack_public_path__ + "static/media/error404-desktop.33274606.jpg";